<nav class="navbar bg-header heightCustom">
  <div class="container-fluid">
    <div class="row align-items-center" style="width: 100%">
      <div class="col">
        <img style="margin-left: 10px; height: 75px" class="p-2" src="../../assets/images/logo-CCI.svg"
             alt="Confcooperative"/>
      </div>
      <div class="col text-center">
        <div class="latopers">GESTIONE REVISIONI</div>
      </div>
      <div class="col text-end">
        <div *ngIf="authService.isLoggedIn">
          <button routerLink="/da-prendere-in-carico" routerLinkActive="d-none"
                  class="btn btn-blue btn-header btn-header-m">
            Revisioni da prendere in carico
          </button>
          <button routerLink="/prese-in-carico" routerLinkActive="d-none" class="btn btn-blue btn-header btn-header-m">
            Revisioni prese in carico
          </button>
          <button class="btn btn-blue btn-header-m" (click)="authService.logOut()">Disconnettiti</button>
        </div>
      </div>
    </div>
  </div>
</nav>

